import React from 'react'
import { createRoot } from 'react-dom/client'
import ConfirmDialog from '../components/ConfirmDialog'

interface ConfirmDialogOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
}

export const dialogUtil = {
  confirm: (options: ConfirmDialogOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      const container = document.createElement('div')
      document.body.appendChild(container)
      const root = createRoot(container)

      const handleConfirm = () => {
        root.unmount()
        document.body.removeChild(container)
        resolve(true)
      }

      const handleCancel = () => {
        root.unmount()
        document.body.removeChild(container)
        resolve(false)
      }

      root.render(
        <ConfirmDialog
          isOpen={true}
          title={options.title}
          message={options.message}
          confirmText={options.confirmText}
          cancelText={options.cancelText}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )
    })
  },
}

export default dialogUtil
